import { isDefined, instanceOfReference, isIsoDate } from "@perxis-auto/shared";
import { ConstructorWidgetEnum } from "../../../../../shared/types/constructor/widget.js";
import { splitCompositeFilterPath } from "../../filterPath/splitCompositeFilterPath.js";
const createFilterQuery = (filterGridItem, filterRawValues, filterValue) => {
  if (!isDefined(filterRawValues) || !isDefined(filterValue) || Array.isArray(filterValue) && !filterValue.length) {
    return null;
  }
  const { path } = splitCompositeFilterPath(filterGridItem.path);
  switch (filterGridItem.type) {
    case ConstructorWidgetEnum.FilterLocation:
    case ConstructorWidgetEnum.FilterMultipleSelect:
    case ConstructorWidgetEnum.FilterCheckboxGroup:
    case ConstructorWidgetEnum.FilterModels:
    case ConstructorWidgetEnum.FilterColorPicker:
    case ConstructorWidgetEnum.FilterDuoColorPicker: {
      const resolvedValue = !Array.isArray(filterValue) ? [filterValue] : filterValue;
      const resolvedRawValues = !Array.isArray(filterRawValues) ? [filterRawValues] : filterRawValues;
      if (!resolvedValue.length && !resolvedRawValues.length) {
        return null;
      }
      if (instanceOfReference(resolvedRawValues[0])) {
        return `${path}.id in ['${resolvedValue.join(`', '`)}']`;
      }
      if (isIsoDate(resolvedRawValues[0])) {
        return `${path} in [Time.Time('${resolvedValue.join(`'), Time.Time('`)}')]`;
      }
      return `${path} in [${resolvedValue.map((v) => typeof v === "string" ? `'${v}'` : v).join(", ")}]`;
    }
    case ConstructorWidgetEnum.FilterSelect: {
      const resolvedRawValues = !Array.isArray(filterRawValues) ? [filterRawValues] : filterRawValues;
      if (!resolvedRawValues.length) {
        return null;
      }
      if (instanceOfReference(resolvedRawValues[0])) {
        return `${path}.id in ['${filterValue}']`;
      }
      if (isIsoDate(resolvedRawValues[0])) {
        return `${path} in [Time.Time('${filterValue}')]`;
      }
      return `${path} in [${typeof filterValue === "string" ? `'${filterValue}'` : filterValue}]`;
    }
    case ConstructorWidgetEnum.FilterSlider: {
      const resolvedRawValues = !Array.isArray(filterRawValues) ? [filterRawValues] : filterRawValues;
      if (instanceOfReference(resolvedRawValues[0]) || !resolvedRawValues.length) {
        return null;
      }
      if (isIsoDate(resolvedRawValues[0])) {
        return `${path} in [Time.Time('${filterValue}-01-01T00:00:00Z')]`;
      }
      return `${path} in [${typeof filterValue === "string" ? `'${filterValue}'` : filterValue}]`;
    }
    case ConstructorWidgetEnum.FilterRangeSlider: {
      const resolvedValue = !Array.isArray(filterValue) ? [filterValue] : filterValue;
      const resolvedRawValues = !Array.isArray(filterRawValues) ? [filterRawValues] : filterRawValues;
      if (resolvedValue.length !== 2 && !resolvedRawValues.length) {
        return null;
      }
      if (isIsoDate(resolvedRawValues[0])) {
        return `${path} >= Time.Time('${resolvedValue[0]}-01-01T00:00:00Z') && ${path} <= Time.Time('${resolvedValue[1]}-01-01T00:00:00Z')`;
      }
      return `${path} >= ${resolvedValue[0]} && ${path} <= ${resolvedValue[1]}`;
    }
    case ConstructorWidgetEnum.FilterOptions: {
      const resolvedValue = !Array.isArray(filterValue) ? [filterValue] : filterValue;
      const resolvedRawValues = !Array.isArray(filterRawValues) ? [filterRawValues] : filterRawValues;
      if (!resolvedValue.length && !resolvedRawValues.length) {
        return null;
      }
      if (!instanceOfReference(resolvedRawValues[0])) {
        return null;
      }
      const packageIds = resolvedRawValues.filter((v) => resolvedValue.includes(v.id)).map((v) => v.packageIds).flat();
      return `package.id in ['${packageIds.join(`', '`)}']`;
    }
    default:
      return null;
  }
};
export {
  createFilterQuery
};
